module.exports = __webpack_public_path__ + "static/userTestingFallback@2x-af1aa9e447d36a5f512ff0c9ae11d695.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/features/prototyping/userTestingFallback@2x.png
// module id = 2620
// module chunks = 168707334958949